import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { C, FONT } from '../theme/tokens';
import HomeScreen from '../screens/HomeScreenSimple';
import RecentCalculationsScreen from '../screens/RecentCalculationsScreen';
import ProgressScreen from '../screens/ProgressScreen';
import HistoryScreen from '../screens/HistoryScreen';
import CalcSearchScreen from '../screens/CalcSearchScreen';
import SettingsScreen from '../screens/SettingsScreen';

const Stack = createStackNavigator();

function useStackScreenOptions() {
  return {
    headerStyle: { backgroundColor: C.panel },
    headerTintColor: C.ink,
    headerTitleStyle: {
      fontFamily: FONT.sansBold,
      fontSize: 16,
      color: C.ink,
    },
    headerShadowVisible: false,
    headerBackTitleVisible: false,
    cardStyle: { backgroundColor: C.bg },
  };
}

export default function HomeNavigator() {
  const screenOptions = useStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="HomeMain" component={HomeScreen} options={{ title: 'Home' }} />
      <Stack.Screen name="RecentCalculations" component={RecentCalculationsScreen} options={{ title: 'Recent' }} />
      <Stack.Screen name="Progress" component={ProgressScreen} options={{ title: 'Coverage' }} />
      <Stack.Screen name="History" component={HistoryScreen} options={{ title: 'History' }} />
      <Stack.Screen name="CalcSearch" component={CalcSearchScreen} options={{ title: 'Search' }} />
      <Stack.Screen name="Settings" component={SettingsScreen} options={{ title: 'Settings' }} />
    </Stack.Navigator>
  );
}
